export default __webpack_public_path__ + "static/media/DFSrecExp.9999e085.md";